import { NEW_ID } from '@/util/constants';
import { Category } from './category.model';

export interface Goal {
  id: number;
  creationDate?: string;
  title: string;
  subTitle: string;
  description: string;
  listTitle: string;
  items: GoalItem[];
  mainCategory: Category;
  subCategory: Category;
  userGoalsCount: number;
  published: boolean;
}

export enum GoalItemType {
  event = 'event',
  header = 'header',
  initiative = 'initiative',
  learningItem = 'learningItem',
  quiz = 'quiz',
}

export interface GoalItem {
  id: number;
  creationDate?: Date;
  updatedDate?: Date;
  column: number;
  type: GoalItemType;
  listHeader: string;
}

export const goalItemTypes = [
  {
    title: 'Event',
    value: GoalItemType.event,
  },
  {
    title: 'Header',
    value: GoalItemType.header,
  },
  {
    title: 'Initiative',
    value: GoalItemType.initiative,
  },
  {
    title: 'Learning Item',
    value: GoalItemType.learningItem,
  },
  {
    title: 'Quiz',
    value: GoalItemType.quiz,
  },
];

export const titleRules = [
  (value: string) => {
    if (value) return true;

    return 'Name is required.';
  },
];

export const descriptionRules = [
  (value: string) => {
    if (value) return true;

    return 'Description is required.';
  },
];

export const defaultGoal = {
  id: NEW_ID,
  title: '',
  description: '',
  subTitle: '',
  listTitle: '',
  published: false,
  items: [],
  userGoalsCount: 0,
  mainCategory: {} as Category,
  subCategory: {} as Category,
};
